export default __webpack_public_path__ + "static/iam_policy_03-82ed3e80d60ae74f9e902c5ff9b40a26.png";